/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CardTransactionEvidenceErrors
 */
export interface CardTransactionEvidenceErrors {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceErrors
     */
    'detectedDpi'?: CardTransactionEvidenceErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceErrors
     */
    'calculatedDpi'?: CardTransactionEvidenceErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceErrors
     */
    'colorGradation'?: CardTransactionEvidenceErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceErrors
     */
    'heightMillis'?: CardTransactionEvidenceErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceErrors
     */
    'widthMillis'?: CardTransactionEvidenceErrorsWidthMillisEnum;
}

export const CardTransactionEvidenceErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceErrorsDetectedDpiEnum = typeof CardTransactionEvidenceErrorsDetectedDpiEnum[keyof typeof CardTransactionEvidenceErrorsDetectedDpiEnum];
export const CardTransactionEvidenceErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceErrorsCalculatedDpiEnum = typeof CardTransactionEvidenceErrorsCalculatedDpiEnum[keyof typeof CardTransactionEvidenceErrorsCalculatedDpiEnum];
export const CardTransactionEvidenceErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type CardTransactionEvidenceErrorsColorGradationEnum = typeof CardTransactionEvidenceErrorsColorGradationEnum[keyof typeof CardTransactionEvidenceErrorsColorGradationEnum];
export const CardTransactionEvidenceErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionEvidenceErrorsHeightMillisEnum = typeof CardTransactionEvidenceErrorsHeightMillisEnum[keyof typeof CardTransactionEvidenceErrorsHeightMillisEnum];
export const CardTransactionEvidenceErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionEvidenceErrorsWidthMillisEnum = typeof CardTransactionEvidenceErrorsWidthMillisEnum[keyof typeof CardTransactionEvidenceErrorsWidthMillisEnum];


